import { render, staticRenderFns } from "./EditorSimpleArray.vue?vue&type=template&id=03bd0b00&"
import script from "./EditorSimpleArray.vue?vue&type=script&lang=js&"
export * from "./EditorSimpleArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports